//@utilities
const { isALowerEnvironment } = require('utilities/environmentHelper')
//@vendor
const { addScriptBugFraud, browserAnalytic } = require('vendor/bugFraud/loadBugFraud')

const checkIfScriptAlreadyExists = (src) => {
  const scripts = Array.from(document.getElementsByTagName('script'))
  const exists = scripts.some(elem => elem.src === src)
  return exists
}

const addBrowserAnalyticScript = () => {
  if (isALowerEnvironment() && !checkIfScriptAlreadyExists(browserAnalytic))
    addScriptBugFraud()
};

module.exports = {
    addBrowserAnalyticScript,
};
